import { render } from "./Sales.vue?vue&type=template&id=37077ede"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/otc/Sales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37077ede"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37077ede', __exports__)) {
    api.reload('37077ede', __exports__)
  }
  
  module.hot.accept("./Sales.vue?vue&type=template&id=37077ede", () => {
    api.rerender('37077ede', render)
  })

}


export default __exports__